import React from "react";

import { Mark } from "@examspark/types/dist/item-stem";

const Correct = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="-64 -64 128 128">
    <circle r="50" fill="#43b421" />
    <path fill="#fff" d="M24-22-9 11-24.5-4.5-35 6-9 32 34-11Z" />
  </svg>
);
const Incorrect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <circle cx="10" cy="10" r="8" fill="#b32e2b" />
    <line x1="6" y1="6" x2="14" y2="14" stroke="white" strokeWidth="2" />
    <line x1="6" y1="14" x2="14" y2="6" stroke="white" strokeWidth="2" />
  </svg>
);

const Marker = (props: { type: Mark }) => {
  let Icon;
  switch (props.type) {
    case "correct":
      Icon = Correct;
      break;
    case "incorrect":
      Icon = Incorrect;
      break;
    default:
      return null;
  }

  return <Icon className="markup" width="20" />;
};
export default Marker;
